// extracted by mini-css-extract-plugin
export var searchHeader = "_7a-0";
export var searchHeaderDark = "_7a-1";